import { render, staticRenderFns } from "./AgencyChooseBeneficiariesReadOnlyView.vue?vue&type=template&id=5932c339&scoped=true&"
import script from "./AgencyChooseBeneficiariesReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseBeneficiariesReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932c339",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
